import {
  ExternalAuthorizationProvider,
  FrontendEnvironment,
  OAuthRedirectTarget,
  PublicCredentials,
} from "platformed-client/types";
import {unreachableCase} from "./typescript";

export function getFrontendEnvironment(): FrontendEnvironment {
  return (window.document as any).platformed_config;
}

function detectDomainType() {
  const {collect_url, trust_url} = getFrontendEnvironment();

  switch (window.location.origin) {
    case trust_url:
      return "TrustCenter";
    case collect_url:
      return "Collect";
    default:
      return null;
  }
}

export const domainType = getFrontendEnvironment().custom_domain?.domain_type ?? detectDomainType();

export function getPublicCredentials(): PublicCredentials {
  return getFrontendEnvironment().credentials;
}

export function getOAuthRedirectUrl(target: OAuthRedirectTarget): string {
  const redirectUrl = new URL(getFrontendEnvironment().app_url);
  redirectUrl.pathname = "/redirect/" + target;

  if (redirectUrl.protocol === "http:") {
    // In some cases we can support OAuth over HTTP by redirecting via
    // localhost, which is special-cased by some servers.
    redirectUrl.hostname = "localhost";
  }
  return redirectUrl.toString();
}

export function oAuthRedirectTargetFromProvider(provider: ExternalAuthorizationProvider): OAuthRedirectTarget {
  switch (provider) {
    case "Google":
      return "google";
    case "Atlassian":
      return "atlassian";
    case "Hubspot":
      return "hubspot";
    case "Slack":
      return "slack";
    case "Microsoft":
      return "microsoft-web";
    case "Docusign":
      return "docusign";
    case "Notion":
      return "notion";
    case "imanage":
      return "imanage";
    case "Manual":
    case "Inflo":
      throw new Error("Not applicable");
    default:
      unreachableCase(provider);
  }
}
